(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotKfzService', AngebotKfzService);

    AngebotKfzService.$inject = [
        '$http',
        '$log',
        '$q',
        '$filter',
        '$injector',
        'AppConfig',
        'FormatUtilsService',
        'BasisAngebotService',
        'AngebotService',
        'moment',
        'lodash',
        'MiscUtilsService',
        'SchluesselWerteUtilsService',
        'ApiService',
        'ApiCacheService',
        'MoneyUtilsService',
        'AlertService',
        'BinaryUtilsService',
        'AngebotUtilsService'
    ];
    function AngebotKfzService($http, $log, $q, $filter, $injector, AppConfig, FormatUtilsService, BasisAngebotService, AngebotService, moment, _, MiscUtilsService, SchluesselWerteUtilsService, ApiService, ApiCacheService, MoneyUtilsService, AlertService, BinaryUtilsService, AngebotUtilsService) {
        var that = this,
            steps = [{
                name: 'rechner.gevo',
                title: 'Geschäftsvorgang',
                disabled: true,
                hidden: true,
                exclude: true,
                group: 'ANGEBOT_START',
                type: 'ENTRY',
                pksLogin: true,
                angebotEmail: false
            }, {
                name: 'rechner.fahrzeug',
                title: 'Fahrzeugdaten',
                disabled: true,
                hidden: false,
                group: 'ANGEBOT',
                angebotEmail: false
            }, {
                name: 'rechner.tarifmerkmale',
                title: 'Ihre Angaben',
                disabled: true,
                hidden: false,
                group: 'ANGEBOT',
                angebotEmail: false
            }, {
                name: 'rechner.ergebnis',
                title: 'Beitragsübersicht',
                disabled: true,
                hidden: false,
                group: 'ANGEBOT'
            }, {
                name: 'rechner.gevo2',
                url: 'rechner.gevo',
                title: 'Antrag',
                disabled: true,
                hidden: true,
                fiktiv: true,
                group: 'ANTRAG'
            }, {
                name: 'rechner.persoenlichedaten',
                title: 'Ihre Daten',
                disabled: true,
                hidden: true,
                group: 'ANTRAG'
            }, {
                name: 'rechner.antrag',
                title: 'Antragsfragen',
                disabled: true,
                hidden: true,
                group: 'ANTRAG'
            }, {
                name: 'rechner.antragpruefen',
                title: 'Abschluss',
                disabled: true,
                hidden: true,
                group: 'ANTRAG'
            }, {
                name: 'rechner.abschluss',
                title: '',
                disabled: true,
                hidden: true,
                group: 'ABSCHLUSS',
                angebotEmail: false,
                angebotLink: false,
                type: 'EXIT'
            }],
            CONSTANTS = {
                produktGruppenSortiert: [
                    'KFZ'
                ],
                bausteineSortiertByProduktGruppe: {
                    KFZ: [
                        'bausteinHaftpflicht',
                        'bausteinTeilkasko',
                        'bausteinVollkasko',
                        'bausteinVerkehrsservice',
                        'bausteinFahrerschutz',
                        'bausteinInsassenunfallInvaliditaet',
                        'bausteinInsassenunfallTod',
                        'bausteinAuslandSchadenschutz',
                        'bausteinCampingInhaltsschutz'
                    ]
                },
                fahrerkreis: {
                    vnFahrzeugnutzer: {
                        wert: true,
                        bezeichnung: 'Versicherungsnehmer'
                    },
                    ehegatteFahrzeugnutzer: {
                        wert: true,
                        bezeichnung: 'Ehegatte'
                    },
                    lebenspartnerFahrzeugnutzer: {
                        wert: true,
                        bezeichnung: 'Lebenspartner in häuslicher Gemeinschaft'
                    },
                    kinderElternFahrzeugnutzer: {
                        wert: true,
                        bezeichnung: 'Kind(er) / Eltern'
                    },
                    sonstigeFahrzeugnutzer: {
                        wert: true,
                        bezeichnung: 'Sonstige Nutzer'
                    }
                },
                nutzungsart: {
                    privat: {
                        wert: 'P',
                        bezeichnung: 'Ausschließlich privat (inkl. Arbeitsweg)'
                    },
                    geschaeftlich: {
                        wert: 'G',
                        bezeichnung: 'Geschäftlich'
                    }
                },
                fahrzeughaltereigenschaften: {
                    versicherungsnehmer: {
                        typ: 'FAHRZEUGHALTEREIGENSCHAFT',
                        wert: '0',
                        bezeichnung: 'Versicherungsnehmer'
                    }
                },
                bausteinHaftpflicht: {
                    tarifarten: [
                        SchluesselWerteUtilsService.create('TARIFART', 'S', 'OPTIMAL', 1),
                        SchluesselWerteUtilsService.create('TARIFART', 'B', 'BASIS', 2)
                    ],
                    deckungssummenText: {
                        '11A': 'inkl. 100 Mio. € Deckungssumme (max. 15 Mio. € je geschädigte Person)',
                        '13K': 'inkl. 7,5 Mio. € gesetzliche Mindestdeckung bei Personenschäden, 1,3 Mio. € bei Sachschäden, 50.000 € bei Vermögensschäden',
                        '11O': 'inkl. 100 Mio. € Deckungssumme (max. 10 Mio. € je geschädigte Person)',
                        '11P': 'inkl. 100 Mio. € Deckungssumme'
                    }
                },
                kaskoarten: [
                    SchluesselWerteUtilsService.create('KASKOART', 'KEINE', 'Ohne Kasko', 1),
                    SchluesselWerteUtilsService.create('KASKOART', 'TEILKASKO', 'Teilkasko', 2),
                    SchluesselWerteUtilsService.create('KASKOART', 'VOLLKASKO', 'Vollkasko', 3)
                ]
            },
            tarifrelevanteAenderungenPropertiesBaustein = [
                'aktiv',
                'produktbausteinnummer.id',
                'tarifartModellierung.wert',
                'deckungscode.wert',
                'leistungsgrenze.code.id',
                'selbstbeteiligung.code.id',
                'deckungssumme.amount',
                'grundlage'
            ],
            tarifrelevanteAenderungenProperties = [
                'angebotsgegenstandFahrzeug.herstellerschluessel', 'angebotsgegenstandFahrzeug.typschluessel', 'angebotsgegenstandFahrzeug.motorradHersteller',
                'angebotsgegenstandFahrzeug.erstzulassung', 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter', 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft',
                'angebotsgegenstandFahrzeug.saisonfahrzeug', 'angebotsgegenstandFahrzeug.saisonzeitraumVon', 'angebotsgegenstandFahrzeug.saisonzeitraumBis',
                'angebotsgegenstandFahrzeug.jaehrlicheFahrleistung', 'angebotsgegenstandFahrzeug.neuwert', 'angebotsgegenstandFahrzeug.zbn', 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter', 'angebotsgegenstandFahrzeug.ortFahrzeughalter',
                'antragsteller.geburtsdatum', 'angebotsgegenstandFahrzeug.fahrerkreis', 'angebotsgegenstandFahrzeug.juengsterFahrer.geburtsdatum', 'angebotsgegenstandFahrzeug.juengsterFahrer.juengsterFahrerHatFuehrerscheinMit17',
                'angebotsgegenstandFahrzeug.aeltesterFahrer.geburtsdatum', 'angebotsgegenstandFahrzeug.aeltesterFahrer.aeltesterFahrerHatFuehrerscheinMit17',
                'angebotsgegenstandFahrzeug.wohneigentum', 'angebotsgegenstandFahrzeug.abstellplatz', 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', 'vorversicherung.wurdeVertragGekuendigtVomVu',
                'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.sondereinstufungMoped', 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.zweitwagenUndPartnerregelung',
                'angebotsgegenstandFahrzeug.kaskoart', 'angebotsgegenstandFahrzeug.rabattschutz', 'angebotsgegenstandFahrzeug.kaskoselect', 'angebotsgegenstandFahrzeug.antiblockiersystem', 'angebotsgegenstandFahrzeug.motorleistung', 'angebotsgegenstandFahrzeug.nutzlast',
                'angebotsgegenstandFahrzeug.sitzplaetze', 'angebotsgegenstandFahrzeug.gfkDach',
                'angebotsgegenstandFahrzeug.quad', 'angebotsgegenstandFahrzeug.nutzungsart', 'angebotsgegenstandFahrzeug.gewerblicheBefoerderung', 'angebotsgegenstandFahrzeug.finanzierung'
            ],
            wagniskennziffern = AppConfig.ANGEBOT.kfz.wkz,
            gevos = AppConfig.ANGEBOT.kfz.gevo,
            evbBeimLadenVorhanden = false;

        that.mapServiceToFormData = mapServiceToFormData;
        that.mapFormToServiceData = mapFormToServiceData;
        that.mapServiceData = mapServiceData;
        that.bereinigeAngebotFuerVergleich = bereinigeAngebotFuerVergleich;
        that.getSteps = getSteps;
        that.getStep = getStep;
        that.getStartStep = getStartStep;
        that.getConstant = getConstant;
        that.isStepGevoErlaubt = isStepGevoErlaubt;
        that.ermittleGevoId = ermittleGevoId;
        that.ermittleGevoFlags = ermittleGevoFlags;
        that.getErsatzgeschaeftDatenAenderbarMap = getErsatzgeschaeftDatenAenderbarMap;
        that.getZulassungsbezirke = getZulassungsbezirke;
        that.getSfkKhKv = getSfkKhKv;
        that.getSfkSondereinstufungZweitwagenFlags = getSfkSondereinstufungZweitwagenFlags;
        that.getFahrzeugDatenHsnTsn = getFahrzeugDatenHsnTsn;
        that.korrigiereBeitraegeByProduktGruppeArray = korrigiereBeitraegeByProduktGruppeArray;
        that.getBeitraegeZusatzInfosToBaustein = getBeitraegeZusatzInfosToBaustein;
        that.getAltvertragBeitragsUebersicht = getAltvertragBeitragsUebersicht;
        that.getAltvertragBeitraegeZusatzInfos = getAltvertragBeitraegeZusatzInfos;
        that.getPdfInfos = getPdfInfos;
        that.getTarifrelevanteAenderungProperties = getTarifrelevanteAenderungProperties;
        that.getAlleProduktGruppenSortiert = getAlleProduktGruppenSortiert;
        that.getAlleBausteineSortiertByProduktGruppe = getAlleBausteineSortiertByProduktGruppe;
        that.getMoeglicheZahlweisen = getMoeglicheZahlweisen;
        that.getZulassungDatumRegeln = getZulassungDatumRegeln;
        that.getSchluesselwerte = getSchluesselwerte;
        that.getAngebotSpezifischeWerte = getAngebotSpezifischeWerte;
        that.isRabattschutzErlaubt = isRabattschutzErlaubt;
        that.isKaskoselectErlaubt = isKaskoselectErlaubt;
        that.isSaisonkennzeichenErlaubt = isSaisonkennzeichenErlaubt;
        that.isPostleitzahlFahrzeughalterErlaubt = isPostleitzahlFahrzeughalterErlaubt;
        that.setFahrzeughalterZbnUndOrt = setFahrzeughalterZbnUndOrt;
        that.isFahrzeughalterReadOnly = isFahrzeughalterReadOnly;
        that.setSfkKhKvSondereinstufungen = setSfkKhKvSondereinstufungen;
        that.getTextZbnOrt = getTextZbnOrt;
        that.getSfkBezeichnung = getSfkBezeichnung;
        that.getErlaubteTarifmerkmale = getErlaubteTarifmerkmale;
        that.isGevo = isGevo;
        that.getErlaubteGeVosZuWkz = getErlaubteGeVosZuWkz;
        that.setFahrzeughalter = setFahrzeughalter;
        that.isFahrzeughalterPlzAbweichend = isFahrzeughalterPlzAbweichend;
        that.getGesamtbeitragLabel = getGesamtbeitragLabel;
        that.getNachrichtenAbschluss = getNachrichtenAbschluss;
        that.isOnlinezulassungErlaubt = isOnlinezulassungErlaubt;
        that.showMeldungen = showMeldungen;
        that.getFilteredFahrzeughaltereigenschaft = getFilteredFahrzeughaltereigenschaft;
        that.getFahrzeughaltereigenschaftBezeichnung = getFahrzeughaltereigenschaftBezeichnung;
        that.onlinezulassungDrucken = onlinezulassungDrucken;
        that.tb28FormularDrucken = tb28FormularDrucken;
        that.rueckwirkenderVertragsbeginnFormularDrucken = rueckwirkenderVertragsbeginnFormularDrucken;
        that.isRueckwirkenderVertragsbeginnErlaubt = isRueckwirkenderVertragsbeginnErlaubt;
        that.getPrintAbschlussType = getPrintAbschlussType;
        that.korrigiereWerteNachGeVoWechsel = korrigiereWerteNachGeVoWechsel;
        that.getTrackingParameter = getTrackingParameter;
        that.getTarifauskunftsdatumLabel = getTarifauskunftsdatumLabel;
        that.getLabelFahrleistung = getLabelFahrleistung;
        that.shouldUpdateVertragsdaten = shouldUpdateVertragsdaten;
        that.isJaehrlicheFahrleistungErlaubt = isJaehrlicheFahrleistungErlaubt;
        that.getRedirectUrlAfterPksLogin = getRedirectUrlAfterPksLogin;
        that.getTestsiegelFilterJsonPath = getTestsiegelFilterJsonPath;
        that.isTarifAb052025 = isTarifAb052025;
        that.isTarifAb052026 = isTarifAb052026;
        that.getAvbVersion = getAvbVersion;
        that.ermittleSelbstbeteiligungen = ermittleSelbstbeteiligungen;
        that.setSelbstbeteiligung = setSelbstbeteiligung;
        that.getBausteinBeitragHaftpflichtKasko = getBausteinBeitragHaftpflichtKasko;
        that.getAbschlussTitle = getAbschlussTitle;
        that.getErgebnisSeiteTitle = getErgebnisSeiteTitle;
        that.getTitleBarSubTitle = getTitleBarSubTitle;
        that.isVorversichererErlaubt = isVorversichererErlaubt;
        that.isVorversicherungInternExternErlaubt = isVorversicherungInternExternErlaubt;
        that.isBisherigesFahrzeugErlaubt = isBisherigesFahrzeugErlaubt;
        that.isGeburtsdatumAntragstellerErlaubt = isGeburtsdatumAntragstellerErlaubt;
        that.isJuengsterFahrerGeburtsdatumErlaubt = isJuengsterFahrerGeburtsdatumErlaubt;
        that.isAeltesterFahrerGeburtsdatumErlaubt = isAeltesterFahrerGeburtsdatumErlaubt;
        that.isVorversicherungsdauerErlaubt = isVorversicherungsdauerErlaubt;
        that.resetDatenPrivatFirmenkunde = resetDatenPrivatFirmenkunde;
        function mapServiceToFormData(angebot, formData, angebotInitial) {
            var zbnFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.zbn'),
                ortFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter'),
                plzFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter'),
                isAngebotAenderbar = BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT'),
                angebotModel = $injector.get('AngebotModel').get(),
                zulassungsbezirk = {
                    ort: ortFahrzeughalter,
                    zbn: zbnFahrzeughalter
                };

            if (!BasisAngebotService.isPrivatPerson(angebot)) {
                if (_.includes(['1', '3'], _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'))) {
                    _.set(formData, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', SchluesselWerteUtilsService.create('FAHRZEUGHALTEREIGENSCHAFT', '4', 'Sonstige Fahrzeughalter', 5));
                } else {
                    _.set(formData, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft'));
                }
            } else {
                _.set(formData, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft'));
            }

            if (_.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert') === _.get(getConstant('fahrzeughaltereigenschaften'), 'versicherungsnehmer.wert')) {
                _.set(formData, 'fahrzeughaltereigenschaftVnAnderePerson', true);

                if (MiscUtilsService.isNotEmpty(BasisAngebotService.getAngebotspartner(angebot, 'antragsteller').postleitzahl)) {
                    _.set(angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter', BasisAngebotService.getAngebotspartner(angebot, 'antragsteller').postleitzahl);
                }
            } else if (MiscUtilsService.isNotEmpty(_.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'))) {
                _.set(formData, 'fahrzeughaltereigenschaftVnAnderePerson', false);
            }
            if (isPostleitzahlFahrzeughalterErlaubt(angebot) && (MiscUtilsService.isNotEmpty(zbnFahrzeughalter) || MiscUtilsService.isNotEmpty(ortFahrzeughalter))) {
                if (MiscUtilsService.isEverythingNotEmpty(zbnFahrzeughalter, ortFahrzeughalter)) {
                    _.set(formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk);
                } else {
                    getZulassungsbezirke(angebotModel, plzFahrzeughalter, true).then(function (zulassungsbezirke) {
                        if (MiscUtilsService.isNotEmpty(zbnFahrzeughalter)) {
                            zulassungsbezirk = _.find(zulassungsbezirke, ['zbn', zbnFahrzeughalter]) || {};
                        } else {
                            zulassungsbezirk = _.find(zulassungsbezirke, ['ort', ortFahrzeughalter]) || {};
                        }

                        if (MiscUtilsService.isNotEmpty(zulassungsbezirk)) {
                            _.set(angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk);

                            if (isAngebotAenderbar) {
                                _.set(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk.ort);
                                _.set(angebot, 'angebotsgegenstandFahrzeug.zbn', zulassungsbezirk.zbn);
                            }

                            if (_.size(zulassungsbezirke) > 1) {
                                _.set(angebotModel.formData, 'zbnManuellGewaehlt', true);
                            }
                        } else {
                            _.set(angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);

                            if (isAngebotAenderbar) {
                                _.set(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);
                                _.set(angebot, 'angebotsgegenstandFahrzeug.zbn', null);
                            }
                        }
                    }).catch(function (error) {});
                }
            }

            _.set(formData, 'rueckwirkenderVertragsbeginn', _.get(angebot, 'rueckwirkenderVertragsbeginn'));

            if (getErlaubteTarifmerkmale(angebot).zulassungAufFahrzeughalter) {
                if (_.get(angebot, 'angebotsgegenstandFahrzeug.erstzulassung') && _.get(angebot, 'angebotsgegenstandFahrzeug.erstzulassung') === _.get(angebot, 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter')) {
                    _.set(formData, 'fahrzeugErstzulassungIdentisch', true);
                } else {
                    _.set(formData, 'fahrzeugErstzulassungIdentisch', false);
                }
            }

            if (_.get(angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl') === 'ZUSAETZLICHES') {
                _.set(formData, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl', true);
            } else if (_.get(angebot, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl')) {
                _.set(formData, 'angebotsgegenstandFahrzeug.bisherigesFahrzeugAuswahl', false);
            }

            ermittleSelbstbeteiligungen(angebot, formData);
            ermittleGevoFlags(angebotModel);
        }
        function mapFormToServiceData(formData, angebot, angebotInitial) {
            var gegenstandFahrzeug = _.get(angebot, 'angebotsgegenstandFahrzeug');

            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                if (getErlaubteTarifmerkmale(angebot).gfkDach) {
                    MiscUtilsService.setDefaultValueIfEmpty(gegenstandFahrzeug, 'gfkDach', false);
                }

                if (getErlaubteTarifmerkmale(angebot).quad) {
                    MiscUtilsService.setDefaultValueIfEmpty(gegenstandFahrzeug, 'quad', false);
                }

                if (!BasisAngebotService.isPrivatPerson(angebot)) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'antragsteller.taetigkeitsschluessel', _.find(BasisAngebotService.getConstant('taetigkeitsschluessel'), ['wert', '0']));
                }

            }
        }
        function mapServiceData(angebot, angebotInitial) {
            var gegenstandFahrzeug = _.get(angebot, 'angebotsgegenstandFahrzeug'),
                schadenfreiheitsklassen = _.get(gegenstandFahrzeug, 'schadenfreiheitsklassen');

            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                _.set(angebot, 'allgemeineAntragsdaten.versicherungsbeginn', _.get(angebot, 'allgemeineDaten.angebotsdatum'));

                if (gegenstandFahrzeug) {
                    MiscUtilsService.setDefaultValueIfEmpty(gegenstandFahrzeug, 'saisonfahrzeug', false);

                    if (_.get(gegenstandFahrzeug, 'nutzungsart.wert') === 'P') {
                        if (_.get(angebot, 'angebotsgegenstandFahrzeug.gewerblicheBefoerderung') === true) {
                            _.set(angebot, 'angebotsgegenstandFahrzeug.gewerblicheBefoerderung', false);
                        }
                    }
                }
            }

            if (schadenfreiheitsklassen && !BasisAngebotService.isErsatzgeschaeft(angebot) && BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                if (schadenfreiheitsklassen.sondereinstufungMoped) {
                    _.set(schadenfreiheitsklassen, 'zweitwagenUndPartnerregelung', false);
                }

                if (schadenfreiheitsklassen.zweitwagenUndPartnerregelung) {
                    _.set(schadenfreiheitsklassen, 'sondereinstufungMoped', false);
                }

                MiscUtilsService.setDefaultValueIfEmpty(schadenfreiheitsklassen, 'sondereinstufungMoped', false);
                MiscUtilsService.setDefaultValueIfEmpty(schadenfreiheitsklassen, 'zweitwagenUndPartnerregelung', false);
            }

            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANTRAG')) {
                if (MiscUtilsService.isNotEmpty(_.get(angebot, 'angebotsgegenstandFahrzeug.kilometerstand'))) {
                    MiscUtilsService.setDefaultValueIfEmpty(angebot, 'angebotsgegenstandFahrzeug.datumKilometerstand', moment().format(AppConfig.API.dateFormat));
                }
            }

            setFahrzeughalter(angebot);

            setSfkKhKvSondereinstufungen();

            if (!isRabattschutzErlaubt(angebot) && BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT') && _.get(angebot, 'angebotsgegenstandFahrzeug.rabattschutz')) {
                _.set(angebot, 'angebotsgegenstandFahrzeug.rabattschutz', false);
            }
        }
        function bereinigeAngebotFuerVergleich(angebot, options) {
            MiscUtilsService.removeProperty(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.kontoverbindungsId', true);
            MiscUtilsService.removeProperty(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.mandatStatus', true);
        }
        function getSteps(angebot) {
            return steps.filter(function (step) {
                if (step.name === 'rechner.gevo') {
                    return isStepGevoErlaubt(angebot);
                } else {
                    return true;
                }
            });
        }
        function getStep(name) {
            return _.find(steps, ['name', name]);
        }
        function getStartStep(angebot, ignoreBeitraegeVorhanden) {
            var step;

            step = !isStepGevoErlaubt(angebot) ? 'rechner.fahrzeug' : 'rechner.gevo';
            step = !ignoreBeitraegeVorhanden && BasisAngebotService.beitraegeVorhanden(angebot) ? 'rechner.ergebnis' : step;

            return step;
        }
        function getConstant(type) {
            return _.get(CONSTANTS, type);
        }
        function isStepGevoErlaubt(angebot) {
            var IntegrationService = $injector.get('IntegrationService'),
                integrationParams = IntegrationService.getIntegrationParams();

            return !(
                integrationParams.angmodus === 'ersatz' ||
                isGevo(angebot, 'KFZ_TARIFUMSTELLUNG')
            );
        }

        function ermittleGevoId(angebotModel) {
            var gevo = null;

            angebotModel = angebotModel || {};

            if (_.get(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug') === 'neuesFahrzeug') {
                if (_.get(angebotModel.formData, 'gevoFahrzeugwechsel')) {
                    if (_.get(angebotModel.formData, 'gevoVorversicherungInternExtern') === false) {
                        gevo = gevos.KFZ_VERSICHERERWECHSEL_NEUES_FZG; // Gevo 4b
                    } else {
                        gevo = gevos.KFZ_FAHRZEUGWECHSEL; // Gevo 4
                    }
                } else if (_.get(angebotModel.formData, 'gevoWeiteresFahrzeug')) {
                    gevo = gevos.KFZ_ZUSAETZLICHER_VERTRAG;
                } else {
                    if (_.get(angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten')) {
                        gevo = gevos.KFZ_TRANSFERBESTIMMUNG_28; // Gevo 1b
                    } else {
                        gevo = gevos.KFZ_NEUGESCHAEFT; // Gevo 1
                    }
                }
            } else if (_.get(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug') === 'versichererwechsel') {
                gevo = gevos.KFZ_VERSICHERERWECHSEL_SELBES_FZG; // Gevo  3
            } else {
                gevo = null;
            }

            _.set(angebotModel.angebot, 'gevoId', gevo);

            return gevo;
        }

        function ermittleGevoFlags(angebotModel) {
            var gevo = _.get(angebotModel.angebot, 'gevoId'),
                vorversicherung = _.get(angebotModel.angebot, 'vorversicherung') || {};

            if (gevo === gevos.KFZ_NEUGESCHAEFT) { // Gevo 1
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'neuesFahrzeug');

            } else if (gevo === gevos.KFZ_TRANSFERBESTIMMUNG_28) { // Gevo 1b
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'neuesFahrzeug');
                _.set(angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten', true);

                if (vorversicherung.vorhanden) {
                    if (vorversicherung.beiWemBestandVorversicherung === BasisAngebotService.getConstant('vorversicherungsarten').unternehmen.wert) {
                        _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', true);
                    } else if (vorversicherung.beiWemBestandVorversicherung === BasisAngebotService.getConstant('vorversicherungsarten').fremdversicherung.wert) {
                        _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', false);
                    }
                } else {
                    _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', undefined);
                }

            } else if (gevo === gevos.KFZ_ZUSAETZLICHER_VERTRAG) { // Gevo 2
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'neuesFahrzeug');
                _.set(angebotModel.formData, 'gevoWeiteresFahrzeug', true);

                if (vorversicherung.vorhanden) {
                    if (vorversicherung.beiWemBestandVorversicherung === BasisAngebotService.getConstant('vorversicherungsarten').unternehmen.wert) {
                        _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', true);
                    } else if (vorversicherung.beiWemBestandVorversicherung === BasisAngebotService.getConstant('vorversicherungsarten').fremdversicherung.wert) {
                        _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', false);
                    }
                } else {
                    _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', undefined);
                }

            } else if (gevo === gevos.KFZ_VERSICHERERWECHSEL_SELBES_FZG) { // Gevo 3
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'versichererwechsel');

            } else if (gevo === gevos.KFZ_FAHRZEUGWECHSEL) { // Gevo 4
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'neuesFahrzeug');
                _.set(angebotModel.formData, 'gevoFahrzeugwechsel', true);
                if (angebotModel.wurdeGeladen) {
                    _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', true);
                }
            } else if (gevo === gevos.KFZ_VERSICHERERWECHSEL_NEUES_FZG) { // Gevo 4b
                _.set(angebotModel.formData, 'gevoVersichererwechselNeuesFahrzeug', 'neuesFahrzeug');
                _.set(angebotModel.formData, 'gevoFahrzeugwechsel', true);
                if (angebotModel.wurdeGeladen) {
                    _.set(angebotModel.formData, 'gevoVorversicherungInternExtern', false);
                }
            }
        }
        function getErsatzgeschaeftDatenAenderbarMap(angebot, angebotInitial) {
            var ersatzgeschaeftDatenAenderbarMap = {},
                ersatzgeschaeftDatenAenderbarMapProps = [
                    'angebotsgegenstandFahrzeug.herstellerschluessel', 'angebotsgegenstandFahrzeug.typschluessel', 'angebotsgegenstandFahrzeug.kennzeichen',
                    'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter', 'angebotsgegenstandFahrzeug.ortFahrzeughalter', 'angebotsgegenstandFahrzeug.zbn',
                    'angebotsgegenstandFahrzeug.erstzulassung', 'angebotsgegenstandFahrzeug.zulassungAufFahrzeughalter', 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', 'angebotsgegenstandFahrzeug.neuwert',
                    'angebotsgegenstandFahrzeug.saisonfahrzeug', 'angebotsgegenstandFahrzeug.saisonzeitraumVon', 'angebotsgegenstandFahrzeug.saisonzeitraumBis',
                    'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko',
                    'angebotsgegenstandFahrzeug.antiblockiersystem', 'angebotsgegenstandFahrzeug.motorradHersteller', 'angebotsgegenstandFahrzeug.motorleistung', 'angebotsgegenstandFahrzeug.nutzlast', 'angebotsgegenstandFahrzeug.sitzplaetze'
                ];

            if (!BasisAngebotService.isErsatzgeschaeft(angebot)) {
                return {};
            }

            _.each(ersatzgeschaeftDatenAenderbarMapProps, function (prop) {
                _.set(ersatzgeschaeftDatenAenderbarMap, prop, MiscUtilsService.isEmpty(_.get(angebotInitial, prop)));
            });

            return ersatzgeschaeftDatenAenderbarMap;
        }
        function getZulassungsbezirke(angebotModel, postleitzahl, checkZbnEindeutig) {
            var tarifkuerzel = _.get(angebotModel, 'tarif.tarifkuerzel'),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKfzZulassungsbezirke, tarifkuerzel, postleitzahl);

            if (MiscUtilsService.isAtLeastOneEmpty(postleitzahl, tarifkuerzel, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http({
                method: 'GET',
                url: serviceUrl,
                cache: true
            }).then(function (response) {
                var zulassungsbezirke = response.data || [];

                if (checkZbnEindeutig && _.uniqBy(zulassungsbezirke, 'zbnBezeichnung').length === 1) {
                    return [zulassungsbezirke[0]];
                }

                return zulassungsbezirke;
            }).catch(function (error) {
                return [];
            });
        }
        function getSfkKhKv(angebotModel, sfksZuGevo) {
            var mandant = _.get(angebotModel, 'angebot.mandant.id'),
                tarifkuerzel = _.get(angebotModel, 'tarif.tarifkuerzel'),
                wkz = _.get(angebotModel, 'angebot.angebotsgegenstandFahrzeug.wkz.wert'),
                gevo = _.get(angebotModel, 'angebot.gevoId'),
                schadenfreiheitsklassen = _.get(angebotModel, 'angebot.angebotsgegenstandFahrzeug.schadenfreiheitsklassen', {}),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKfzSfkKhKv, tarifkuerzel, mandant, wkz);

            if (MiscUtilsService.isAtLeastOneEmpty(mandant, tarifkuerzel, wkz, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http({
                method: 'GET',
                url: serviceUrl,
                params: {
                    stichtag: (
                        _.get(angebotModel, 'angebot.stichtagTarif') ||
                        BasisAngebotService.getTarifauskunftsdatum(angebotModel.angebot) ||
                        moment().format(AppConfig.API.dateFormat)
                    ),
                    gevoId: sfksZuGevo ? gevo : null,
                    hukIdKh: gevo === gevos.KFZ_TARIFUMSTELLUNG ? _.get(schadenfreiheitsklassen, 'haftpflicht.id.id') : null,
                    hukIdKv: gevo === gevos.KFZ_TARIFUMSTELLUNG ? _.get(schadenfreiheitsklassen, 'vollkasko.id.id') : null
                },
                cache: true,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return [];
            });
        }
        function getSfkSondereinstufungZweitwagenFlags(angebotModel) {
            return $q(function (resolve, reject) {
                var geaendert = false,
                    serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKfzSfkSondereinstufungZweitwagenFlags, angebotModel.tarif.tarifkuerzel),
                    result,
                    cacheId = serviceUrl;

                geaendert = BasisAngebotService.hatAenderungen(angebotModel.angebot, angebotModel.angebotSondereinstufungen);
                angebotModel.angebotSondereinstufungen = _.cloneDeep(angebotModel.angebot);

                if (ApiCacheService.isCached(cacheId) && !geaendert) {
                    result = ApiCacheService.get(cacheId);

                    $log.debug('AngebotKfzService.getSfkSondereinstufungenFlags CACHE', result);
                    return resolve(result);
                }

                return $http({
                    method: 'POST',
                    url: serviceUrl,
                    data: angebotModel.angebot
                }).then(function (response) {
                    result = response.data;

                    ApiCacheService.put(cacheId, result);

                    return resolve(result);
                }).catch(function (error) {
                    angebotModel.angebotSondereinstufungen = null;
                    ApiCacheService.remove(cacheId);
                    return reject(error);
                });
            });
        }
        function getFahrzeugDatenHsnTsn(angebotModel) {
            var tarifkuerzel = _.get(angebotModel, 'tarif.tarifkuerzel'),
                herstellerschluessel = _.toUpper(_.get(angebotModel, 'angebot.angebotsgegenstandFahrzeug.herstellerschluessel')),
                typschluessel = _.toUpper(_.get(angebotModel, 'angebot.angebotsgegenstandFahrzeug.typschluessel')),
                serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKfzFzgBezeichnungNeuwert, tarifkuerzel, herstellerschluessel, typschluessel);

            if (MiscUtilsService.isAtLeastOneEmpty(herstellerschluessel, typschluessel, tarifkuerzel, serviceUrl)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            return $http({
                method: 'GET',
                url: serviceUrl,
                params: {
                    stichtag: (
                        _.get(angebotModel, 'angebot.stichtagTarif') ||
                        BasisAngebotService.getTarifauskunftsdatum(angebotModel.angebot) ||
                        moment().format(AppConfig.API.dateFormat)
                    )
                },
                cache: true,
                globalErrorsIgnore: {
                    errors: true
                }
            }).then(function (response) {
                return response.data || {};
            }).catch(function (error) {
                return {};
            });
        }

        function korrigiereBeitraegeByProduktGruppeArray(beitraegeByProduktGruppeArray) {
            _.forEach(_.get(beitraegeByProduktGruppeArray, 'KFZ'), function (bausteinBeitrag) {
                if (bausteinBeitrag.bausteinKey === 'bausteinInsassenunfallInvaliditaet') {
                    var bausteinInsassenunfallTod = _.find(_.get(beitraegeByProduktGruppeArray, 'KFZ'), ['bausteinKey', 'bausteinInsassenunfallTod']);

                    _.set(bausteinBeitrag.beitrag, _.get(bausteinInsassenunfallTod, 'baustein.tarifartModellierung.wert') + '.brutto', MoneyUtilsService.summation.apply(null, _.map([bausteinBeitrag.beitrag, bausteinInsassenunfallTod.beitrag], function (beitrag) {
                        return _.get(beitrag[_.get(bausteinInsassenunfallTod, 'baustein.tarifartModellierung.wert')], 'brutto');
                    })));

                    _.set(bausteinBeitrag.beitrag, _.get(bausteinInsassenunfallTod, 'baustein.tarifartModellierung.wert') + '.netto', MoneyUtilsService.summation.apply(null, _.map([bausteinBeitrag.beitrag, bausteinInsassenunfallTod.beitrag], function (beitrag) {
                        return _.get(beitrag[_.get(bausteinInsassenunfallTod, 'baustein.tarifartModellierung.wert')], 'netto');
                    })));
                }
            });

            _.remove(_.get(beitraegeByProduktGruppeArray, 'KFZ'), function (el) {
                return el.bausteinKey === 'bausteinInsassenunfallTod';
            });

            return beitraegeByProduktGruppeArray;
        }
        function getBeitraegeZusatzInfosToBaustein(angebot, baustein, bausteinKey, options) {
            var zusatzInfos = {
                label: {
                    deckung: null,
                    zusatz: null
                }
            };

            if (MiscUtilsService.isEmpty(baustein)) {
                return zusatzInfos;
            }
            if (bausteinKey === 'bausteinHaftpflicht') {
                zusatzInfos.label.deckung = 'Kfz-Haftpflichtversicherung';
            } else if (bausteinKey === 'bausteinTeilkasko') {
                zusatzInfos.label.deckung = 'Teilkaskoversicherung';

                if (options.type !== 'ANTRAG_PRUEFEN') {
                    zusatzInfos.label.deckung += isKaskoselectErlaubt(angebot) && _.get(angebot, 'angebotsgegenstandFahrzeug.kaskoselect') ? ' inkl. Kasko-SELECT' : '';
                }
            } else if (bausteinKey === 'bausteinVollkasko') {
                zusatzInfos.label.deckung = 'Vollkaskoversicherung';

                if (options.type !== 'ANTRAG_PRUEFEN') {
                    zusatzInfos.label.deckung += isKaskoselectErlaubt(angebot) && _.get(angebot, 'angebotsgegenstandFahrzeug.kaskoselect') ? ' inkl. Kasko-SELECT' : '';
                }
            } else if (bausteinKey === 'bausteinVerkehrsservice') {
                zusatzInfos.label.deckung = 'Schutzbrief';
            } else if (bausteinKey === 'bausteinFahrerschutz') {
                zusatzInfos.label.deckung = 'Fahrerschutz';
            } else if (bausteinKey === 'bausteinInsassenunfallInvaliditaet') {
                zusatzInfos.label.deckung = 'Kfz-Unfallversicherung';

                if (options.type === 'ANTRAG_PRUEFEN') {
                    zusatzInfos.label.zusatz = 'Versicherungssumme bei Invalidität: ' + $filter('moneyString')(baustein.deckungssumme, 'symbol', '+', 0) + '<br>';
                    zusatzInfos.label.zusatz += 'Versicherungssumme im Todesfall: ' + $filter('moneyString')(_.get(angebot, 'bausteinInsassenunfallTod.deckungssumme'), 'symbol', '+', 0);
                }

            } else if (bausteinKey === 'bausteinAuslandSchadenschutz') {
                zusatzInfos.label.deckung = 'Ausland-Schadenschutz';
            } else if (_.startsWith(bausteinKey, 'bausteinEMobilPlus')) {
                zusatzInfos.label.deckung = 'E-Mobil Plus';
            } else if (bausteinKey === 'bausteinCampingInhaltsschutz') {
                zusatzInfos.label.deckung = 'Camping-Inhaltsschutz';
            }

            return zusatzInfos;
        }
        function getAltvertragBeitragsUebersicht(angebot, zahlweiseAltvertrag) {
            var altvertragBeitraege = {
                    KFZ: []
                },
                objekt = _.get(angebot, 'ersatzgeschaeft.objekte[0]'),
                objIu = {},
                bausteineIu = {},
                zahlweisen = AppConfig.ANGEBOT.zahlweisen,
                beitragsArt,
                zahlweise;

            if (!objekt) {
                return altvertragBeitraege;
            }

            zahlweiseAltvertrag = zahlweiseAltvertrag || _.get(objekt, 'zahlweise'); // Default = Prämie gemäß Zahlweise
            altvertragBeitraege.KFZ.bausteine = [];

            if (_.get(zahlweiseAltvertrag, 'wert') === zahlweisen.JAEHRLICH.wert && !_.get(objekt, 'saisonKennzeichen', false)) {
                zahlweise = SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.JAEHRLICH.wert, zahlweisen.JAEHRLICH.bezeichnung);
                beitragsArt = 'jahresbeitrag';
            } else {
                zahlweise = _.get(objekt, 'zahlweise');
                beitragsArt = 'praemie';
            }

            _.each(objekt.bausteine, function (baustein) {
                var obj = {
                    beitrag: {},
                    baustein: baustein,
                    bausteinKey: baustein.tarifUnterArt
                };
                if (_.includes(['IU_INV', 'IU_TOD'], baustein.tarifUnterArt)) {
                    bausteineIu[baustein.tarifUnterArt] = baustein;
                    return true;
                }
                obj.beitrag = {
                    apiKey: AngebotService.getApiKeyString(baustein.tarifUnterArt, _.get(zahlweise, 'wert')),
                    brutto: baustein[beitragsArt],
                    zahlweise: zahlweise
                };

                obj.infos = getAltvertragBeitraegeZusatzInfos(angebot, obj);
                altvertragBeitraege.KFZ.push(obj);
            });
            if (bausteineIu && bausteineIu.IU_INV && bausteineIu.IU_TOD) {
                objIu = {
                    baustein: bausteineIu,
                    beitrag: {
                        apiKey: AngebotService.getApiKeyString('IU', _.get(zahlweise, 'wert')),
                        brutto: MoneyUtilsService.summation(bausteineIu.IU_INV[beitragsArt], bausteineIu.IU_TOD[beitragsArt]),
                        zahlweise: _.get(zahlweise, 'zahlweise')
                    },
                    bausteinKey: 'IU'
                };

                objIu.infos = getAltvertragBeitraegeZusatzInfos(angebot, objIu);
                altvertragBeitraege.KFZ.push(objIu);
            }

            return altvertragBeitraege;
        }
        function getAltvertragBeitraegeZusatzInfos(angebot, obj) {
            if (!obj) {
                return {};
            }

            var produktbausteinName = _.get(obj, 'baustein.produktbausteinName') || '',
                bausteinTexte,
                zusatzInfos = {
                    label: {
                        deckung: null,
                        zusatz: null
                    }
                },
                deckungssummeIuTod,
                deckungssummeIuInv;

            produktbausteinName = produktbausteinName.replace(/(: \$ #\s*)$/, '');
            bausteinTexte = produktbausteinName.split(/\r?\n/);

            zusatzInfos.label.deckung = bausteinTexte[0];
            if (obj.bausteinKey === 'KH') {
                zusatzInfos.label.zusatz = _.replace(_.get(obj, 'baustein.leistungsgrenzeBezeichner'), 'Haftpflicht', '');
            } else if (_.includes(['KT', 'KV'], obj.bausteinKey)) {
                zusatzInfos.label.zusatz = _.get(obj, 'baustein.selbstbeteiligungBezeichner');
            } else if (obj.bausteinKey === 'IU') {
                deckungssummeIuTod = _.get(obj, 'baustein.IU_TOD.deckungssumme');
                deckungssummeIuInv = _.get(obj, 'baustein.IU_INV.deckungssumme');

                if (MiscUtilsService.isEverythingEmpty(deckungssummeIuTod, deckungssummeIuInv)) {
                    zusatzInfos.label.zusatz = bausteinTexte[1];
                } else {
                    zusatzInfos.label.deckung = 'Insassenunfall';
                    zusatzInfos.label.zusatz = [];

                    if (MiscUtilsService.isNotEmpty(deckungssummeIuTod)) {
                        zusatzInfos.label.zusatz.push('Todesfall', $filter('moneyString')(deckungssummeIuTod, 'code', '+', 2));
                    }

                    if (MiscUtilsService.isNotEmpty(deckungssummeIuInv)) {
                        if (zusatzInfos.label.zusatz.length) {
                            zusatzInfos.label.zusatz.push('und');
                        }
                        zusatzInfos.label.zusatz.push('Invalidität', $filter('moneyString')(deckungssummeIuInv, 'code', '+', 2));
                    }

                    zusatzInfos.label.zusatz = zusatzInfos.label.zusatz.join(' ');
                }
            }

            if (_.get(zusatzInfos, 'label.zusatz')) {
                zusatzInfos.label.zusatz = [
                    '<span class="info-text">',
                    zusatzInfos.label.zusatz,
                    '</span>'
                ].join('');
            }

            return zusatzInfos;
        }
        function getPdfInfos(angebot, produktGruppe) {
            var linkProduktGruppeText,
                linkProduktseite,
                produktGruppeBezeichnung,
                vertragsunterlagenVorhanden = true,
                wkz = _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
                avbNummer = BasisAngebotService.getAvbVersion(angebot, '91'),
                pdfName;

            linkProduktseite = AppConfig.APP.urls.homepage + '/';
            pdfName = 'kfz' + (avbNummer < 39 ? '-alt' : '');

            if (produktGruppe === 'KFZ') {
                produktGruppeBezeichnung = 'Kraft&shy;fahrzeug&shy;versicherung';

                if (wkz === wagniskennziffern.PKW) {
                    linkProduktseite += 'auto';
                } else if (wkz === wagniskennziffern.MOTORRAD) {
                    linkProduktseite += 'kfz';
                } else if (_.includes([
                    wagniskennziffern.LEICHTKRAFTROLLER_BIS_80_CCM,
                    wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM,
                    wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM
                ], wkz)) {
                    linkProduktseite += 'kfz';
                } else if (wkz === wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE) {
                    linkProduktseite += 'kfz';
                } else if (wkz === wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR) {
                    linkProduktseite += 'kfz';
                } else if (wkz === wagniskennziffern.WOHNWAGENANHAENGER) {
                    linkProduktseite += 'kfz';
                } else {
                }

                linkProduktGruppeText = 'zur ' + produktGruppeBezeichnung;
            } else {
                return null;
            }

            return {
                pdfName: pdfName,
                produktGruppeBezeichnung: produktGruppeBezeichnung,
                linkProduktGruppeText: linkProduktGruppeText,
                vertragsunterlagenVorhanden: vertragsunterlagenVorhanden,
                linkProduktseite: linkProduktseite,
                vertragsunterlagenInhaltTpl: 'kfz.html'
            };
        }
        function getTarifrelevanteAenderungProperties(angebot) {
            var bausteineKeys = BasisAngebotService.getBausteineKeys(angebot),
                bausteinProperties,
                properties = [];

            bausteinProperties = _.map(bausteineKeys, function (bausteinKey) {
                return _.map(tarifrelevanteAenderungenPropertiesBaustein, function (bausteinProp) {
                    return [bausteinKey, bausteinProp].join('.');
                });
            });

            if (isTarifAb052025(angebot)) {
                properties.push('vorversicherung.vorversicherungsdauer.wert');
            }

            return _.union(tarifrelevanteAenderungenProperties, _.flatten(bausteinProperties), properties);
        }
        function getAlleProduktGruppenSortiert() {
            return getConstant('produktGruppenSortiert');
        }
        function getAlleBausteineSortiertByProduktGruppe() {
            return getConstant('bausteineSortiertByProduktGruppe');
        }
        function getMoeglicheZahlweisen(angebotModel, onlyIfBeitragExists) {
            var moeglicheZahlweisen = [],
                zahlweisen = AppConfig.ANGEBOT.zahlweisen;

            if (_.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug')) {
                moeglicheZahlweisen.push(SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.JAEHRLICH.wert, zahlweisen.JAEHRLICH.bezeichnung));
            } else {
                moeglicheZahlweisen = [
                    SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.JAEHRLICH.wert, zahlweisen.JAEHRLICH.bezeichnung),
                    SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.HALBJAEHRLICH.wert, zahlweisen.HALBJAEHRLICH.bezeichnung),
                    SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.VIERTELJAEHRLICH.wert, zahlweisen.VIERTELJAEHRLICH.bezeichnung),
                    SchluesselWerteUtilsService.create('ZAHLWEISE', zahlweisen.MONATLICH.wert, zahlweisen.MONATLICH.bezeichnung)
                ];
            }

            if (onlyIfBeitragExists) {
                return _.filter(moeglicheZahlweisen, function (moeglicheZahlweise) {
                    return MoneyUtilsService.getAmount(_.get(_.find(_.get(angebotModel.angebot, 'ergebnisLetzteBerechnung.gesamtergebnis'), ['zahlweise.wert', moeglicheZahlweise.wert]), 'gesamtBrutto')) > 0;
                });
            } else {
                return moeglicheZahlweisen;
            }
        }
        function getZulassungDatumRegeln(angebot) {
            var minDatum = moment('1930-01-01').format(AppConfig.API.dateFormat);
            if (isGevo(angebot, 'KFZ_VERSICHERERWECHSEL_SELBES_FZG')) {
                return {
                    min: minDatum,
                    max: moment().subtract(1, 'days').format(AppConfig.API.dateFormat)
                };
            } else {
                return {
                    min: minDatum,
                    max: moment(_.get(angebot, 'rahmenDaten.angebotsdatumMax'), AppConfig.API.dateFormat).format(AppConfig.API.dateFormat)
                };
            }
        }
        function getSchluesselwerte(angebot) {
            var sw = {},
                sortWert = {
                    params: {
                        sort: 'wert'
                    }
                },
                sortSortierKz = {
                    params: {
                        sort: 'sortierKz'
                    }
                },
                noopPromise = function () {
                    return $q(function (resolve) {
                        resolve([]);
                    });
                },
                wkz = _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
                swServices = [
                    SchluesselWerteUtilsService.fetch('immobilien', sortWert),
                    SchluesselWerteUtilsService.fetch('abstellplatz', sortWert),
                    SchluesselWerteUtilsService.fetch('finanzierung', sortSortierKz, 'angebotssystem/'),
                    SchluesselWerteUtilsService.fetch('fahrzeughaltereigenschaft', sortWert, 'angebotssystem/'),
                    (wkz === '3' ? SchluesselWerteUtilsService.fetch('hersteller', {
                        params: {
                            wkz: wkz
                        }
                    }) : noopPromise()),
                    (wkz === '501' ? SchluesselWerteUtilsService.fetch('aufbauart', {
                        params: {
                            wkz: wkz
                        }
                    }) : noopPromise()),
                    isTarifAb052025(angebot) ? SchluesselWerteUtilsService.fetch('vorverdauer', sortWert, null, AppConfig.API.services.angKfzSwVorverdauerPrefix) : SchluesselWerteUtilsService.fetch('vorverdauer', sortWert),
                    SchluesselWerteUtilsService.fetch('rolleMitversicherungsnehmerKfz', sortWert)
                ];

            return $q.all(_.filter(swServices)).then(function (schluesselwerte) {
                sw.immobilien = _.orderBy(_.compact(_.uniqBy(_.union(MiscUtilsService.filterArray(schluesselwerte[0], ['1', '2', '3'], 'wert'), [_.get(angebot, 'angebotsgegenstandFahrzeug.wohneigentum')]), 'wert')), ['sortierKz'], ['asc']);
                sw.abstellplatz = _.orderBy(_.compact(_.uniqBy(_.union(MiscUtilsService.filterArray(schluesselwerte[1], ['1', '3', 'N'], 'wert'), [_.get(angebot, 'angebotsgegenstandFahrzeug.abstellplatz')]), 'wert')), ['sortierKz'], ['asc']);
                sw.finanzierung = schluesselwerte[2];
                sw.fahrzeughaltereigenschaft = schluesselwerte[3];
                sw.hersteller = schluesselwerte[4];
                sw.aufbauart = schluesselwerte[5];
                sw.vorverdauer = schluesselwerte[6];
                sw.rolleMitversicherungsnehmerKfz = schluesselwerte[7];

                return sw;
            }).catch(function (error) {});
        }
        function getAngebotSpezifischeWerte() {
            var angebotModel = $injector.get('AngebotModel').get();

            return $q.all([
                getSfkKhKv(angebotModel),
                getSfkKhKv(angebotModel, true)
            ]).then(function (data) {
                return {
                    schadenfreiheitsklassen: {
                        haftpflicht: data[0].klassenHaftpflicht,
                        vollkasko: data[0].klassenVollkasko
                    },
                    schadenfreiheitsklassenZuGevo: {
                        haftpflicht: data[1].klassenHaftpflicht,
                        vollkasko: data[1].klassenVollkasko
                    }
                };
            }).catch(function () {
                return {
                    schadenfreiheitsklassen: {
                        haftpflicht: [],
                        vollkasko: []
                    },
                    schadenfreiheitsklassenZuGevo: {
                        haftpflicht: [],
                        vollkasko: []
                    }
                };
            });
        }
        function isRabattschutzErlaubt(angebot) {
            var schadenfreiheitsklassen = _.get(angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen', {}),
                grundjahrSfkKh = parseInt(_.get(schadenfreiheitsklassen, 'haftpflicht.grundjahr'), 10),
                grundjahrSfkKv = parseInt(_.get(schadenfreiheitsklassen, 'vollkasko.grundjahr'), 10),
                grundjahrSfkKhAbweichend = parseInt(_.get(schadenfreiheitsklassen, 'haftpflichtAbweichend.grundjahr'), 10),
                grundjahrSfkKvAbweichend = parseInt(_.get(schadenfreiheitsklassen, 'vollkaskoAbweichend.grundjahr'), 10),
                bausteinVollkaskoAktiv = BasisAngebotService.isBausteinAktiv(angebot, 'bausteinVollkasko'),
                sfUnter4 = false;

            _.each([{
                grundjahr: grundjahrSfkKh,
                type: 'haftpflicht'
            }, {
                grundjahr: grundjahrSfkKv,
                type: 'vollkasko'
            }, {
                grundjahr: grundjahrSfkKhAbweichend,
                type: 'haftpflicht'
            }, {
                grundjahr: grundjahrSfkKvAbweichend,
                type: 'vollkasko'
            }], function (sfk) {
                if (sfk.grundjahr < 4 && sfk.grundjahr !== -1) { // -1 = kein SFR hinterlegt
                    if (sfk.type === 'vollkasko' && bausteinVollkaskoAktiv || sfk.type === 'haftpflicht') {
                        sfUnter4 = true;
                        return false;
                    }
                }
            });

            return !sfUnter4 && getErlaubteTarifmerkmale(angebot).rabattschutz;
        }
        function isKaskoselectErlaubt(angebot) {
            if (getErlaubteTarifmerkmale(angebot).kaskoselect === false) {
                return false;
            }

            if (BasisAngebotService.isBausteinAktiv(angebot, 'bausteinVollkasko') || BasisAngebotService.isBausteinAktiv(angebot, 'bausteinTeilkasko')) {
                return true;
            }

            return false;
        }
        function isSaisonkennzeichenErlaubt(angebot) {
            return getErlaubteTarifmerkmale(angebot).saisonkennzeichen;
        }
        function isPostleitzahlFahrzeughalterErlaubt(angebot) {
            return (
                getErlaubteTarifmerkmale(angebot).postleitzahl
            );
        }
        function setFahrzeughalterZbnUndOrt(angebot, zulassungsbezirk) {
            _.set(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', _.get(zulassungsbezirk, 'ort'));
            _.set(angebot, 'angebotsgegenstandFahrzeug.zbn', _.get(zulassungsbezirk, 'zbn'));
            _.set(angebot, 'angebotsgegenstandFahrzeug.zbnBezeichnung', _.get(zulassungsbezirk, 'zbnBezeichnung'));
        }
        function setSfkKhKvSondereinstufungen(angebotModel) {
            var schadenfreiheitsklassen,
                sfKlasseSondereinstufungen = AppConfig.ANGEBOT.kfz.sfKlasseSondereinstufungen;

            angebotModel = angebotModel || $injector.get('AngebotModel').get();

            if (!angebotModel || !BasisAngebotService.isAngebotAenderbar(angebotModel.angebot, 'ANGEBOT') || BasisAngebotService.isErsatzgeschaeft(angebotModel.angebot)) {
                return;
            }

            schadenfreiheitsklassen = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen', {});

            if (!schadenfreiheitsklassen.sondereinstufungMoped && !schadenfreiheitsklassen.zweitwagenUndPartnerregelung && !schadenfreiheitsklassen.sondereinstufungYD) {
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflichtAbweichend', null);
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkaskoAbweichend', null);

                return;
            }

            getSfkKhKv(angebotModel).then(function (sfKlassen) {
                if (schadenfreiheitsklassen.sondereinstufungMoped && _.size(sfKlasseSondereinstufungen.MOPED) === 1) {
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', _.find(sfKlassen.klassenHaftpflicht, { klasse: sfKlasseSondereinstufungen.MOPED[0] }));
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.find(sfKlassen.klassenVollkasko, { klasse: sfKlasseSondereinstufungen.MOPED[0] }));
                }

                if (schadenfreiheitsklassen.zweitwagenUndPartnerregelung && _.size(sfKlasseSondereinstufungen.ZWEITWAGEN) === 1) {
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', _.find(sfKlassen.klassenHaftpflicht, { klasse: sfKlasseSondereinstufungen.ZWEITWAGEN[0] }));
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.find(sfKlassen.klassenVollkasko, { klasse: sfKlasseSondereinstufungen.ZWEITWAGEN[0] }));
                }

                if (schadenfreiheitsklassen.sondereinstufungYD && _.size(sfKlasseSondereinstufungen.YD) === 1) {
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht', _.find(sfKlassen.klassenHaftpflicht, { klasse: sfKlasseSondereinstufungen.YD[0] }));
                    _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.find(sfKlassen.klassenVollkasko, { klasse: sfKlasseSondereinstufungen.YD[0] }));
                }
            }).catch(function (error) {});
        }
        function getTextZbnOrt(zulassungsbezirk, showOnlyOrt) {
            var zbnOrt = {},
                angebotModel = $injector.get('AngebotModel').get();

            if (!angebotModel || !angebotModel.angebot) {
                return '';
            }

            if (zulassungsbezirk) {
                zbnOrt = {
                    ort: zulassungsbezirk.ort,
                    zbnBezeichnung: zulassungsbezirk.zbnBezeichnung
                };
            } else {
                zbnOrt = {
                    ort: _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter'),
                    zbnBezeichnung: _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.zbnBezeichnung')
                };
            }

            if (showOnlyOrt) {
                return zbnOrt.ort;
            } else {
                return [
                    zbnOrt.zbnBezeichnung,
                    ' (', zbnOrt.ort, ')'
                ].join('');
            }
        }
        function getSfkBezeichnung(sfklasse) {
            if (MiscUtilsService.isEmpty(sfklasse)) {
                return '';
            }

            if (sfklasse.klasse === '-1') {
                return sfklasse.text;
            }

            return sfklasse.klasse;
        }
        function getErlaubteTarifmerkmale(angebot) {
            return _.get(angebot, 'erlaubteTarifmerkmale', {});
        }
        function isGevo(angebot, gevo) {
            var angebotGevoId = _.get(angebot, 'gevoId'),
                gevoKeys = _.castArray(gevo);

            if (MiscUtilsService.isAtLeastOneEmpty(angebotGevoId)) {
                return false;
            }

            return _.includes(_.values(_.pickBy(gevos, function (value, key) {
                return _.includes(gevoKeys, key);
            })), angebotGevoId);
        }
        function getErlaubteGeVosZuWkz(wkzNummer) {
            var serviceUrl = FormatUtilsService.replace(AppConfig.API.services.angKfzErlaubteGeVosZuWkz, wkzNummer);

            return $http({
                method: 'GET',
                url: serviceUrl,
                cache: true
            }).then(function (response) {
                return response.data;
            }).catch(function (error) {
                return {};
            });
        }
        function setFahrzeughalter(angebot) {
            var vnFahrzeughaltereigenschaft = _.get(getConstant('fahrzeughaltereigenschaften'), 'versicherungsnehmer.wert'),
                angebotModel = $injector.get('AngebotModel').get(),
                antragsteller = _.cloneDeep(_.get(angebot, 'antragsteller')),
                fahrzeughaltereigenschaft = _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'),
                fahrzeughaltereigenschaftOriginal = _.get(angebotModel.angebotOriginal, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'),
                postleitzahlFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter'),
                ortFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter'),
                zbnFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.zbn'),
                fahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter') || {},
                isAngebotAenderbar = BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT'),
                zulassungsbezirk;

            if (!BasisAngebotService.isAngebotAenderbar(angebot, 'ANTRAG')) {
                return;
            }
            if (fahrzeughaltereigenschaft === vnFahrzeughaltereigenschaft) {
                _.set(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter', antragsteller);

                if (isAngebotAenderbar) {
                    _.set(angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter', antragsteller.postleitzahl);
                }
                getZulassungsbezirke(angebotModel, antragsteller.postleitzahl, false).then(function (zulassungsbezirke) {
                    if (MiscUtilsService.isNotEmpty(zbnFahrzeughalter) && MiscUtilsService.isNotEmpty(ortFahrzeughalter)) {
                        zulassungsbezirk = _.find(zulassungsbezirke, {
                            zbn: zbnFahrzeughalter,
                            ort: ortFahrzeughalter
                        }) || {};
                    } else if (MiscUtilsService.isNotEmpty(zbnFahrzeughalter)) {
                        zulassungsbezirk = _.find(zulassungsbezirke, ['zbn', zbnFahrzeughalter]) || {};
                    } else {
                        zulassungsbezirk = _.find(zulassungsbezirke, ['ort', antragsteller.ort]) || {};
                    }

                    if (MiscUtilsService.isNotEmpty(zulassungsbezirk)) {
                        _.set(angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk);
                        if (isAngebotAenderbar) {
                            _.set(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', zulassungsbezirk.ort);
                            _.set(angebot, 'angebotsgegenstandFahrzeug.zbn', zulassungsbezirk.zbn);
                        }

                        if (_.size(zulassungsbezirke) > 1) {
                            _.set(angebotModel.formData, 'zbnManuellGewaehlt', true);
                        }
                    } else {
                        _.set(angebotModel.formData, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);
                        if (isAngebotAenderbar) {
                            _.set(angebot, 'angebotsgegenstandFahrzeug.ortFahrzeughalter', null);
                            _.set(angebot, 'angebotsgegenstandFahrzeug.zbn', null);
                        }
                    }
                }).catch(function (error) {});
            } else {
                if (
                    !isFahrzeughalterReadOnly(angebot) &&
                    !(
                        fahrzeughalter.postleitzahl &&
                        fahrzeughalter.ort &&
                        postleitzahlFahrzeughalter === _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.postleitzahl') &&
                        new RegExp(_.escapeRegExp(ortFahrzeughalter)).test(fahrzeughalter.ort)
                    )
                ) {
                    if (postleitzahlFahrzeughalter) {
                        _.set(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.postleitzahl', postleitzahlFahrzeughalter);
                    }
                    if (ortFahrzeughalter) {
                        _.set(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.ort', ortFahrzeughalter);
                    }
                }
                if (
                    (fahrzeughaltereigenschaft || vnFahrzeughaltereigenschaft) !== (fahrzeughaltereigenschaftOriginal || vnFahrzeughaltereigenschaft) &&
                    _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.partnernummer')
                ) {
                    _.set(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.partnernummer', null);
                }
            }
        }
        function isFahrzeughalterReadOnly(angebot) {
            return (
                (!!_.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.partnernummer.id') &&
                    !BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')
                ) ||
                _.get(angebot, 'aenderbareTarifmerkmale.fahrzeughalterdaten') === false
            );
        }
        function isFahrzeughalterPlzAbweichend(angebot, context) {
            var fahrzeughaltereigenschaften = BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebot),
                vnFahrzeughaltereigenschaft = _.get(fahrzeughaltereigenschaften, 'versicherungsnehmer.wert'),
                fahrzeughalterEigenschaft = _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert'),
                postleitzahlFahrzeughalter = _.get(angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter'),
                postleitzahlAntragsteller = _.get(angebot, 'antragsteller.postleitzahl'),
                abwFahrzeughalterPostleitzahl = _.get(angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter.postleitzahl'),
                erlaubteTarifmerkmale = getErlaubteTarifmerkmale(angebot),
                fahrzeughalterPlzAbweichend = {
                    status: false,
                    type: ''
                };

            context = context || 'ANGEBOT';
            if (isFahrzeughalterReadOnly(angebot)) {
                return fahrzeughalterPlzAbweichend;
            }
            if (
                MiscUtilsService.isEverythingNotEmpty(fahrzeughalterEigenschaft, postleitzahlFahrzeughalter, postleitzahlAntragsteller) &&
                fahrzeughalterEigenschaft === vnFahrzeughaltereigenschaft &&
                postleitzahlFahrzeughalter !== postleitzahlAntragsteller &&
                BasisAngebotService.isAngebotAenderbar(angebot, context) &&
                !isGevo(angebot, 'KFZ_TARIFUMSTELLUNG') &&
                (
                    (
                        isPostleitzahlFahrzeughalterErlaubt(angebot) &&
                        context === 'ANGEBOT' &&
                        erlaubteTarifmerkmale.fahrzeughalter
                    ) ||
                    context === 'ANTRAG'
                )
            ) {
                fahrzeughalterPlzAbweichend.status = true;
                fahrzeughalterPlzAbweichend.type = 'VN_ANTRAGSTELLER';
            }
            if (
                MiscUtilsService.isEverythingNotEmpty(fahrzeughalterEigenschaft, postleitzahlFahrzeughalter, postleitzahlAntragsteller, abwFahrzeughalterPostleitzahl) &&
                fahrzeughalterEigenschaft !== vnFahrzeughaltereigenschaft &&
                postleitzahlFahrzeughalter !== abwFahrzeughalterPostleitzahl &&
                BasisAngebotService.isAngebotAenderbar(angebot, context) &&
                !isGevo(angebot, 'KFZ_TARIFUMSTELLUNG') &&
                (
                    (

                        context === 'ANGEBOT' &&
                        isPostleitzahlFahrzeughalterErlaubt(angebot)
                    ) ||
                    context === 'ANTRAG'
                )
            ) {
                fahrzeughalterPlzAbweichend.status = true;
                fahrzeughalterPlzAbweichend.type = 'ABW_HALTER';
            }

            return fahrzeughalterPlzAbweichend;
        }
        function getGesamtbeitragLabel(angebot) {
            return 'Gesamtbeitrag' + (isSaisonkennzeichenErlaubt(angebot) && _.get(angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug') ? ' für die Saison' : '');
        }
        function getNachrichtenAbschluss(angebotModel) {
            var evbNummer = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.evbNummer'),
                evbAbrufbarBis = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.evbAbrufbarBis'),
                onlinezulassungErlaubt,
                nachrichten = [];

            return $q(function (resolve, reject) {
                if (
                    MiscUtilsService.isEverythingNotEmpty(evbNummer, evbAbrufbarBis) &&
                    !evbBeimLadenVorhanden
                ) {
                    isOnlinezulassungErlaubt(angebotModel).then(function (erlaubt) {
                        onlinezulassungErlaubt = erlaubt;
                    }).catch(function () {
                    }).finally(function () {
                        $log.log('onlinezulassungErlaubt', onlinezulassungErlaubt);

                        nachrichten.push(_.template(AppConfig.MESSAGES.nachrichtAbschlussEvb, { variable: 'data' })({
                            evbNummer: evbNummer,
                            evbAbrufbarBis: moment(evbAbrufbarBis, AppConfig.API.dateFormat).format('DD.MM.YYYY'),
                            onlinezulassungErlaubt: onlinezulassungErlaubt
                        }));

                        return resolve(_.map(nachrichten, function (nachricht) {
                            return AlertService.create(nachricht, ApiService.NACHRICHTEN_TYPES.INFO.alertType, false);
                        }));
                    });
                } else {
                    return resolve(_.map(nachrichten, function (nachricht) {
                        return AlertService.create(nachricht, ApiService.NACHRICHTEN_TYPES.INFO.alertType, false);
                    }));
                }
            });
        }

        function isOnlinezulassungErlaubt(angebotModel) {
            var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                angebotsToken = BasisAngebotService.getToken(angebotModel.angebot),
                doppelkartennummer = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.doppelkartennummer'),
                serviceUrl = AppConfig.API.services.angKfzCheckOnlinezulassung;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, doppelkartennummer)) {
                return $q.resolve(false);
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken, doppelkartennummer);

            return $http({
                method: 'GET',
                url: serviceUrl,
                cache: false
            }).then(function (response) {
                return response.data === 'JA';
            }).catch(function () {
                return false;
            });
        }
        function showMeldungen(angebot) {
            var evbNummer = _.get(angebot, 'angebotsgegenstandFahrzeug.evbNummer'),
                aenderbareTarifmerkmale = _.get(angebot, 'aenderbareTarifmerkmale');

            if (
                MiscUtilsService.isEverythingNotEmpty(evbNummer, aenderbareTarifmerkmale) &&
                BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT') &&
                _.size(_.pickBy(aenderbareTarifmerkmale, function (val) {
                    return val === false;
                })) > 0
            ) {
                evbBeimLadenVorhanden = true;
                AlertService.add({
                    message: FormatUtilsService.replace(AppConfig.MESSAGES.angebotDatenNichtAenderbarEvb, evbNummer),
                    type: 'info',
                    permanent: true,
                    id: 'ANG_DATEN_NICHT_AENDERBAR_EVB'
                });
            }
        }
        function getFilteredFahrzeughaltereigenschaft(angebot, fahrzeughaltereigenschaftSw) {
            var FAHRZEUGHALTEREIGENSCHAFT_VN = _.get(getConstant('fahrzeughaltereigenschaften'), 'versicherungsnehmer.wert');

            if (!BasisAngebotService.isPrivatPerson(angebot)) {
                return [
                    SchluesselWerteUtilsService.create('FAHRZEUGHALTEREIGENSCHAFT', '2', 'Autohaus/Kaufpreisrabatt', 3),
                    SchluesselWerteUtilsService.create('FAHRZEUGHALTEREIGENSCHAFT', '4', 'Sonstige Fahrzeughalter', 5)
                ];
            }

            return _.reject(fahrzeughaltereigenschaftSw, function (fahrzeughaltereigenschaft) {
                return _.includes([FAHRZEUGHALTEREIGENSCHAFT_VN], _.get(fahrzeughaltereigenschaft, 'wert'));
            });
        }

        function getFahrzeughaltereigenschaftBezeichnung(angebot, fahrzeughaltereigenschaft) {
            if (BasisAngebotService.isPrivatPerson(angebot)) {
                return _.get(fahrzeughaltereigenschaft, 'bezeichnung');
            }

            if (_.get(fahrzeughaltereigenschaft, 'wert') === '2') {
                return 'Autohaus/Kaufpreisrabatt';
            } else if (_.get(fahrzeughaltereigenschaft, 'wert') === '4') {
                return 'Sonstige Fahrzeughalter';
            } else {
                return _.get(fahrzeughaltereigenschaft, 'bezeichnung');
            }
        }
        function onlinezulassungDrucken(angebotModel) {
            var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                angebotsToken = BasisAngebotService.getToken(angebotModel.angebot),
                doppelkartennummer = _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.doppelkartennummer'),
                serviceUrl = AppConfig.API.services.angKfzOnlinezulassungDrucken;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken, doppelkartennummer)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken, doppelkartennummer);

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: 'arraybuffer'
            }).then(function (response) {
                var fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                return {
                    binary: response.ata,
                    filename: fileInfos.filename,
                    mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                };
            }).catch(function (error) {
                return $q.reject(error);
            });
        }
        function tb28FormularDrucken(angebotModel) {
            var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                angebotsToken = BasisAngebotService.getToken(angebotModel.angebot),
                serviceUrl = AppConfig.API.services.angKfzTB28Formular;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken);

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: 'arraybuffer'
            }).then(function (response) {
                var fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                return {
                    binary: response.data,
                    filename: fileInfos.filename,
                    mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                };
            });
        }
        function rueckwirkenderVertragsbeginnFormularDrucken(angebotModel) {
            var angebotsnummer = BasisAngebotService.getAngebotsnummer(angebotModel.angebot),
                angebotsToken = BasisAngebotService.getToken(angebotModel.angebot),
                serviceUrl = AppConfig.API.services.angKfzRueckwirkenderVertragsbeginnFormular;

            if (MiscUtilsService.isAtLeastOneEmpty(angebotsnummer, angebotsToken)) {
                return $q.reject('NICHT_ALLE_DATEN_VORHANDEN');
            }

            serviceUrl = FormatUtilsService.replace(serviceUrl, angebotModel.tarif.tarifkuerzel, angebotsnummer, angebotsToken);

            return $http({
                method: 'GET',
                url: serviceUrl,
                responseType: 'arraybuffer'
            }).then(function (response) {
                var fileInfos = ApiService.getFileinfosFromHeader(response.headers()['filename-upload']);

                return {
                    binary: response.data,
                    filename: fileInfos.filename,
                    mimeType: BinaryUtilsService.getMimeType(fileInfos.extension)
                };
            });
        }
        function isRueckwirkenderVertragsbeginnErlaubt(angebotModel) {
            return (
                getErlaubteTarifmerkmale(_.get(angebotModel, 'angebot')).rueckwirkenderVertragsbeginn &&
                _.get(angebotModel, 'angebot.rueckwirkenderVertragsbeginn') === true
            );
        }
        function getPrintAbschlussType(angebot) {
            var gevo = _.get(angebot, 'gevoId');

            if (AppConfig.APP.printAbschlussType === 'REPORT') {
                if (gevo !== gevos.KFZ_TARIFUMSTELLUNG) {
                    return AppConfig.APP.printAbschlussType;
                } else {
                    return 'HTML';
                }
            } else {
                return AppConfig.APP.printAbschlussType;
            }
        }
        function korrigiereWerteNachGeVoWechsel(angebot, isChangeEvent) {
            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANTRAG')) {
                if (!isGevo(angebot, [
                    'KFZ_TRANSFERBESTIMMUNG_28', // '1b'
                    'KFZ_VERSICHERERWECHSEL_SELBES_FZG' // '3'
                ]) &&
                    _.get(angebot, 'rabattuebertragung.vorversicherungAufDritten') === true
                ) {
                    if (isGevo(angebot, [
                        'KFZ_NEUGESCHAEFT', // '1'
                        'KFZ_FAHRZEUGWECHSEL', // 4
                        'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b
                    ]) && !BasisAngebotService.isPrivatPerson(angebot)) {
                    } else {
                        _.set(angebot, 'rabattuebertragung.vorversicherungAufDritten', false);
                    }
                }
            }

            if (BasisAngebotService.isAngebotAenderbar(angebot, 'ANGEBOT')) {
                if (isChangeEvent !== false) {
                    _.set(angebot, 'angebotsgegenstandFahrzeug.fahrgestellnummer', null);
                    _.set(angebot, 'angebotsgegenstandFahrzeug.andereHersteller', null);
                    _.set(angebot, 'angebotsgegenstandFahrzeug.motorradHersteller', null);
                }

                if (isGevo(angebot, [
                    'KFZ_NEUGESCHAEFT', // '1'
                    'KFZ_ZUSAETZLICHER_VERTRAG' // '2'
                ])) {
                    _.set(angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.vollkasko', _.get(angebot, 'angebotsgegenstandFahrzeug.schadenfreiheitsklassen.haftpflicht'));
                }
            }
        }
        function getTrackingParameter(angebot, trackingProvider, trackingEvent, variableName, trackingType) {
            if (_.includes([
                'hurra'
            ], trackingProvider)) {
                if (variableName === 'u5') {
                    return _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert');
                }
            }
        }
        function getTarifauskunftsdatumLabel(angebot) {
            if (isGevo(angebot, 'KFZ_VERSICHERERWECHSEL_SELBES_FZG')) {
                return 'Wann soll Ihre Versicherung beginnen?';
            }

            return null;
        }
        function getLabelFahrleistung(angebot) {
            return _.get(angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug') ? 'Voraussichtliche Fahrleistung pro Saison' : 'Voraussichtliche Fahrleistung pro Jahr';
        }
        function shouldUpdateVertragsdaten(angebotModel) {
            var gevo = _.get(angebotModel, 'angebot.gevoId');

            return (
                gevo === gevos.KFZ_TARIFUMSTELLUNG &&
                !MiscUtilsService.isEqual(BasisAngebotService.getTarifauskunftsdatum(angebotModel.angebot), BasisAngebotService.getTarifauskunftsdatum(angebotModel.angebotLetzterRefresh))
            );
        }
        function isJaehrlicheFahrleistungErlaubt(angebot) {
            var erlaubteTarifmerkmale = getErlaubteTarifmerkmale(angebot),
                wkz = _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert');

            return (
                (!_.get(angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug') &&
                    erlaubteTarifmerkmale.jaehrlicheFahleistung
                ) || (
                    erlaubteTarifmerkmale.jaehrlicheFahleistung &&
                    _.includes([
                        wagniskennziffern.LEICHTKRAFTROLLER_50_BIS_125_CCM,
                        wagniskennziffern.LEICHTKRAFTRAEDER_50_BIS_135_CCM,
                        wagniskennziffern.CAMPINGKRAFTWAGEN_WOHNMOBILE
                    ], wkz)
                ) || (
                    erlaubteTarifmerkmale.jaehrlicheFahleistung &&
                    _.includes([
                        wagniskennziffern.PKW,
                        wagniskennziffern.MOTORRAD
                    ], wkz) &&
                    isTarifAb052025(angebot)
                )
            );
        }
        function getRedirectUrlAfterPksLogin(angebot) {
            var wkz = _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert'),
                redirectUrl = AppConfig.INTEGRATION.redirectUrlAfterPksLogin;

            if (wkz) {
                redirectUrl = redirectUrl + '&p_wkz=' + wkz;
            }

            return redirectUrl;
        }

        function getTestsiegelFilterJsonPath(angebotModal) {
            return _.get(angebotModal.angebot, 'angebotsgegenstandFahrzeug.wkz.wert');
        }

        function isTarifAb052025(angebot) {
            return getAvbVersion(angebot, '91') >= 39;
        }

        function isTarifAb052026(angebot) {
            return getAvbVersion(angebot, '91') >= 40;
        }
        function getAvbVersion(angebot, produktNr) {
            if (produktNr === '91') {
                return parseInt(_.get(angebot, 'avb.id'), 10) || 0;
            }

            return null;
        }

        function ermittleSelbstbeteiligungen(angebot, formData) {
            var vollkaskoSelbstbeteiligung,
                teilkaskoSelbstbeteiligung;

            if (_.get(angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'VOLLKASKO') {
                vollkaskoSelbstbeteiligung = _.get(angebot, 'bausteinVollkasko.selbstbeteiligung.betrag');
                teilkaskoSelbstbeteiligung = _.get(angebot, 'bausteinVollkasko.selbstbeteiligung.betrag2');
                _.set(formData, 'bausteinVollkaskoSelbstbeteiligung', vollkaskoSelbstbeteiligung);
                _.set(formData, 'bausteinTeilkaskoSelbstbeteiligung', teilkaskoSelbstbeteiligung);
            } else if (_.get(angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'TEILKASKO') {
                teilkaskoSelbstbeteiligung = _.get(angebot, 'bausteinTeilkasko.selbstbeteiligung.betrag');
                _.set(formData, 'bausteinTeilkaskoSelbstbeteiligung', teilkaskoSelbstbeteiligung);
            }
        }

        function setSelbstbeteiligung(angebotModel) {
            var selbstbeteiligung,
                selbstbeteiligungVollkasko = _.get(angebotModel.formData, 'bausteinVollkaskoSelbstbeteiligung'),
                selbstbeteiligungTeilkasko = _.get(angebotModel.formData, 'bausteinTeilkaskoSelbstbeteiligung');

            if (
                (
                    _.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'VOLLKASKO' &&
                    (
                        !selbstbeteiligungVollkasko || !selbstbeteiligungTeilkasko
                    )
                ) || !selbstbeteiligungTeilkasko
            ) {
                return;
            }

            if (_.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'VOLLKASKO') {
                selbstbeteiligung = _.filter(_.filter(_.get(angebotModel.angebot, 'bausteinVollkasko.zasZapAnfrageErgebnis.selbstbeteiligungen'), ['betrag.amount', selbstbeteiligungVollkasko.amount]), ['betrag2.amount', selbstbeteiligungTeilkasko.amount]);
                _.set(angebotModel.angebot, 'bausteinVollkasko.selbstbeteiligung', selbstbeteiligung[0]);

            } else if (_.get(angebotModel.angebot, 'angebotsgegenstandFahrzeug.kaskoart') === 'TEILKASKO') {
                selbstbeteiligung = _.filter(_.get(angebotModel.angebot, 'bausteinTeilkasko.zasZapAnfrageErgebnis.selbstbeteiligungen'), ['betrag.amount', selbstbeteiligungTeilkasko.amount]);
                _.set(angebotModel.angebot, 'bausteinTeilkasko.selbstbeteiligung', selbstbeteiligung[0]);
            }
        }

        function getBausteinBeitragHaftpflichtKasko(beitraegeByProduktGruppe) {
            var bausteinBeitragHaftpflichtKasko = _.get(beitraegeByProduktGruppe, 'KFZ.bausteinHaftpflicht'),
                bausteinBeitragVollkasko = _.get(beitraegeByProduktGruppe, 'KFZ.bausteinVollkasko'),
                bausteinBeitragTeilkasko = _.get(beitraegeByProduktGruppe, 'KFZ.bausteinTeilkasko');

            _.forEach(_.get(bausteinBeitragHaftpflichtKasko, 'baustein.moeglicheTarifarten'), function (tarifart) {
                _.set(bausteinBeitragHaftpflichtKasko.beitrag, tarifart.wert + '.brutto', MoneyUtilsService.summation.apply(null, _.map(_.compact([bausteinBeitragHaftpflichtKasko.beitrag, _.get(bausteinBeitragVollkasko, 'beitrag'), _.get(bausteinBeitragTeilkasko, 'beitrag')]), function (beitrag) {
                    return _.get(beitrag[tarifart.wert], 'brutto');
                })));

                _.set(bausteinBeitragHaftpflichtKasko.beitrag, tarifart.wert + '.netto', MoneyUtilsService.summation.apply(null, _.map(_.compact([bausteinBeitragHaftpflichtKasko.beitrag, _.get(bausteinBeitragVollkasko, 'beitrag'), _.get(bausteinBeitragTeilkasko, 'beitrag')]), function (beitrag) {
                    return _.get(beitrag[tarifart.wert], 'netto');
                })));
            });

            return bausteinBeitragHaftpflichtKasko;
        }

        function getAbschlussTitle(angebot) {
            return 'Hurra! &ndash; Sie haben es geschafft!';
        }
        function getErgebnisSeiteTitle(angebot) {
            var zahlweiseWert = BasisAngebotService.getZahlweise(angebot).wert,
                title = 'Ihr persönlicher Beitrag';

            switch (zahlweiseWert) {
            case '51':
                if (_.get(angebot, 'angebotsgegenstandFahrzeug.saisonfahrzeug') === true) {
                    title = 'Beitrag pro Saison';
                } else {
                    title = 'Beitrag pro Jahr';
                }
                break;
            case '50':
                title = 'Beitrag pro Halbjahr';
                break;
            case '49':
                title = 'Beitrag pro Vierteljahr';
                break;
            case '48':
                title = 'Beitrag pro Monat';
                break;
            case '47':
                title = 'Ihr Einmalbeitrag';
                break;
            }

            return title;
        }

        function getTitleBarSubTitle(angebot) {
            return AppConfig.ANGEBOT.kfz.subTitle[_.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert')] || AppConfig.ANGEBOT.produktSubText;
        }

        function isVorversichererErlaubt(angebotModel) {
            return (
                (
                    getErlaubteTarifmerkmale(angebotModel.angebot).vorversicherung &&
                    !isVorversicherungInternExternErlaubt()
                ) || (
                    getErlaubteTarifmerkmale(angebotModel.angebot).vorversicherung &&
                    isVorversicherungInternExternErlaubt() &&
                    !_.isNil(_.get(angebotModel.formData, 'gevoVorversicherungInternExtern'))
                )
            );
        }

        function isVorversicherungInternExternErlaubt(angebot) {
            return (
                isGevo(angebot, ['KFZ_TRANSFERBESTIMMUNG_28', 'KFZ_ZUSAETZLICHER_VERTRAG']) && // Gevo 1b, 2
                getErlaubteTarifmerkmale(angebot).vorversicherung
            );
        }

        function isBisherigesFahrzeugErlaubt(angebot) {
            var wkz = _.get(angebot, 'angebotsgegenstandFahrzeug.wkz.wert');

            return (
                isGevo(angebot, [
                    'KFZ_FAHRZEUGWECHSEL', // 4
                    'KFZ_VERSICHERERWECHSEL_NEUES_FZG' // 4b
                ]) &&
                wkz.wagnisgruppe !== '4' &&
                !_.includes([
                    wagniskennziffern.ANHAENGER_WERKNAH_UND_PRIVATVERKEHR, // 501
                    wagniskennziffern.WOHNWAGENANHAENGER // 541
                ], wkz)
            );
        }
        function isGeburtsdatumAntragstellerErlaubt(angebot) {
            return (
                BasisAngebotService.isPrivatPerson(angebot) &&
                (AngebotUtilsService.getAntragstellerDatenAenderbarMap(angebot).geburtsdatum || !BasisAngebotService.isErsatzgeschaeft(angebot))
            );
        }
        function isJuengsterFahrerGeburtsdatumErlaubt(angebot) {
            return (
                BasisAngebotService.isPrivatPerson(angebot) &&
                getErlaubteTarifmerkmale(angebot).geburtsjahrJuengsterFahrer
            );
        }
        function isAeltesterFahrerGeburtsdatumErlaubt(angebot) {
            return (
                BasisAngebotService.isPrivatPerson(angebot) &&
                getErlaubteTarifmerkmale(angebot).geburtsjahrAeltesterFahrer
            );
        }

        function isVorversicherungsdauerErlaubt(angebot) {
            return (
                getErlaubteTarifmerkmale(angebot).dauerVorversicherung &&
                isTarifAb052025(angebot)
            );
        }
        function resetDatenPrivatFirmenkunde(resetDaten, angebotModel) {
            var privatkunde = _.get(angebotModel.formData, 'antragsteller.privatkunde'),
                vorversicherungAufDritten = _.get(angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten');

            _.set(angebotModel.angebot, 'antragsteller', _.get(angebotModel.angebotInitial, 'antragsteller'));
            _.set(angebotModel.angebot, 'empfangsBestaetigungEmailAdresse', null);

            _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter', null);
            _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft', null);
            _.set(angebotModel.formData, 'antragsteller', {});
            _.set(angebotModel.formData, 'antragsteller.privatkunde', privatkunde);
            _.set(angebotModel.formData, 'fahrzeughaltereigenschaftVnAnderePerson', null);

            if (resetDaten === 'privatkunde') {
                _.set(angebotModel.angebot, 'rabattuebertragung', null);
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.juengsterFahrer', {});
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.aeltesterFahrer', {});
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.wohneigentum', null);
                _.set(angebotModel.angebot, 'angebotsgegenstandFahrzeug.abstellplatz', null);
            } else if (resetDaten === 'firmenkunde') {
                _.set(angebotModel.angebot, 'mitversicherungsnehmer.partnerMitversicherungsnehmer', null);
                _.set(angebotModel.angebot, 'mitversicherungsnehmer.rolle', null);
            }
            _.set(angebotModel.angebot, 'rabattuebertragung.vorversicherungAufDritten', vorversicherungAufDritten);
        }
    }

})();
